module.exports = __webpack_public_path__ + "static/media/infoPopupIcon.3156e51d.svg";